export default class TaxItem {
    id = 0;
    name = '';
}